export default __webpack_public_path__ + "static/media/CoursePageInfo.ed66cd6b.png";